import { createFileRoute } from '@tanstack/react-router'
import { TalentLibraryPage } from '@/features/organizations/talent-library'

export const Route = createFileRoute('/_authenticated/org/$orgId/talents/')({
  component: TalentLibraryRouteComponent,
})

function TalentLibraryRouteComponent() {
  const { orgId } = Route.useParams()
  return <TalentLibraryPage orgId={orgId} />
}
